// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1_aI0","selects":"Documents_selects__2EJ8i"};